import { AppBar, Toolbar, IconButton, Avatar, Box, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

interface ConversationDetailHeaderProps {
  name: string;
  offerTitle: string;
  onBack: () => void;
}

const getInitials = (name: string) => {
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
};

export function ConversationDetailHeader({
  name,
  offerTitle,
  onBack,
}: ConversationDetailHeaderProps) {
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: 'primary.main',
        borderRadius: '0 0 16px 16px',
        zIndex: theme => theme.zIndex.appBar,
        paddingTop: 'env(safe-area-inset-top)',
      }}
      data-testid="conversation-detail-header"
    >
      <Toolbar sx={{ gap: 2 }}>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onBack}
          aria-label="back to messages"
          data-testid="back-button"
        >
          <ArrowBack />
        </IconButton>

        <Avatar
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.3)',
            color: 'white',
            width: 48,
            height: 48,
          }}
          data-testid="contact-avatar"
        >
          {getInitials(name)}
        </Avatar>

        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: 'white',
              fontWeight: 600,
              lineHeight: 1.2,
            }}
            data-testid="contact-name"
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '0.875rem',
            }}
            data-testid="offer-title"
          >
            {offerTitle}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
